﻿//import $ from "jquery";
//window.$ = $;
//window.jQuery = $;


import "./plugins/cpiBreadCrumbs";
import "./plugins/accordionTabs";
import "./plugins/clearSearch";
import "./plugins/collapsibleSidebar";
import "./plugins/disableControls";
import "./plugins/entryForm";
import "./plugins/filterCount";
import "./plugins/floatLabels";
import "./plugins/isInViewport";
import "./plugins/liveSearch";
import "./plugins/mainButtons";
import "./plugins/popupEntryForm";
import "./plugins/recordNavigator";
import "./plugins/refineSearch";
import "./plugins/resetElements";
import "./plugins/scrollingTabs";
import "./plugins/searchForm";
import "./plugins/stickyTabs";
import "./plugins/resetPickLists";
import "./plugins/moreInfo";
import "./plugins/wasValidated";
import "./plugins/lightBox";
import "./plugins/sorter";
import "./plugins/saveCaretPosition";
import "./plugins/textOverflow";





